"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycAdminRoutes = void 0;
const route_1 = require("../../route");
class KycAdminRoutes extends route_1.Route {
    constructor() {
        super('admin/kyc');
    }
    getDocumentsToReview() {
        return this.get('/manual_review');
    }
    getIdDocuments() {
        return this.get('/id_documents');
    }
    getIdDocument(docId) {
        return this.get(`/id_document/${encodeURIComponent(docId)}`);
    }
    postIdDocumentInfo(docId, infoBody) {
        return this.post(`/id_document/info/${encodeURIComponent(docId)}`, infoBody);
    }
    manualAccept(docId) {
        return this.post(`/id_document/manual_accept/${encodeURIComponent(docId)}`);
    }
    manualReject(docId, reason) {
        return this.post(`/id_document/manual_reject/${encodeURIComponent(docId)}`, { reason });
    }
}
exports.KycAdminRoutes = KycAdminRoutes;
//# sourceMappingURL=kyc.js.map